import { memo } from 'react';

import { SettingsSubSideNavAccountSection } from '~/components/v2/components/workspace/settings-nav/items/SettingsSubSideNavAccountSection';
import { SettingsSubSideNavWorkspaceSection } from '~/components/v2/components/workspace/settings-nav/items/SettingsSubSideNavWorkspaceSection';
import { SubSideNavScrollbar } from '~/components/v2/components/workspace/sub-side-nav/SubSideNavScrollbar';

export const SettingsSubSideNav = memo(() => {
  return (
    <div className="flex min-h-0 grow flex-col" data-testid="SETTINGS_SUB_SIDE_NAV">
      <SubSideNavScrollbar>
        <SettingsSubSideNavWorkspaceSection />
        <SettingsSubSideNavAccountSection />
      </SubSideNavScrollbar>
    </div>
  );
});

SettingsSubSideNav.displayName = 'SettingsSubSideNav';
